import { kidsData } from '../lib/data';
import styles from './Kids.module.scss';

const Kids = () => {
    return ( 
        <section className = {styles.container}>
           
                {kidsData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="детские фото Ставрополь"/>
                    </div>
                ))}
          
        </section>
     );
}
 
export default Kids;